import { MDBAlert, MDBBtn, MDBIcon, MDBInputGroup, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import dotsIcon from "../../../components/images/Send_Receive.svg";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  addNewUsersToBlfGroup,
  editUsersfieldsUnderBlfGroup,
  getAgentsInAccount,
  getExistingBlfUSersUnderGroup,
  removeBlfUser,
  confirmDeleteUserinPhones,
  getphoneErrors
} from "../../../apiclients/streamsapi_bridge";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import PopupLoader from "../../../views/popups/PopupLoader";
import SaveChanges from "../saveCancel";
import RemoveBlfUserPopu from "../../../views/popups/phonesystem/RemoveBlfUser";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { Tooltip } from "react-tooltip";
import PhoneErrorAlertpop from "../../../views/popups/phonesystem/phoneErrorAlert";

export default function BlfUsers(props) {
  const [usersInGroup, setUsersInGroup] = useState([]);
  const [userDatarows, setUserDatarows] = useState([]);
  const [existetOrdesList, setExistetOrdesList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
  const [AddUser, setAddUser] = useState(false);
  const closeTogglePopup = () => setAddUser(!AddUser);
  const [groupid] = useState(props.groupid);
  const [tabvalue] = useState(props.tabValue);
  console.log("tabvalue :::::::::::::: " + tabvalue);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [agentsInAccount, setAgentsInAccount] = useState([]);
  const addUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(true);
  const [phoneErrorpop, setphoneErrorpop] = useState(false);
  const [errorDevices, setErrorDevices] = useState([]);
  function handleClick() {
    addUserRef.current.click();
  }


  const getListStyle = () => ({});
  const {
    register,
    control,
    reset,
    formState: { dirtyFields, isDirty, errors },
    handleSubmit,
    setError,
    setValue,
    trigger,
    getValues,
  } = useForm({
    defaultValues: { users: usersInGroup },
  });
  const { fields, append, remove, replace, update, move } = useFieldArray({
    control,
    name: "users",
  });
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const [isloading, setIsloading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const { t, i18n } = useTranslation();
  const [filteredUserDatarows, setFilteredUserDatarows] = useState([]);
  const searchRef = useRef(null);
  const UserDataTable = {
    columns: [
      { label: "Order", field: "Order" },
      { label: "Name", field: "Name" },
      { label: "Extension", field: "Extension" },
      { label: "Label", field: "Label" },
     // { label: "Ring", field: "Ring" },
      { label: "Remove", field: "Remove", sort: false },
    ],
    rows: filteredUserDatarows,
  };
  const toggleRemoveBlfUserpopup = async () => setRemoveBlfUser(!removeBlfUserInfo);
  const togglephoneErrorpopup = async () => setphoneErrorpop(!phoneErrorpop);
  const [removeBlfUserInfo, setRemoveBlfUser] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  console.log("userDatarows  " + JSON.stringify(userDatarows));
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    console.log(result);
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    move(source.index, destination.index);
    usersInGroup.map((data, index) => {
      setValue(`users[${index}].userId`, data.userId, { shouldDirty: true });
    });
    return;

    // const newItems = Array.from(userDatarows);
    // // console.log(
    // //   "newItems ::::::::::::::::: 11111111111111 " +
    // //     JSON.stringify(userDatarows)
    // // );
    // // );
    // const dataMap = new Map();
    // getValues("users").map((data, index) => {
    //   console.log("userid map " + data.userId);
    //   dataMap.set(data.userId, data);
    // });
    // const draggedItem = newItems[Number(draggableId)];
    // newItems.splice(source.index, 1);
    // newItems.splice(destination.index, 0, draggedItem);
    // console.log("Before UsersGroup : " + JSON.stringify(usersInGroup));
    // //let currentUsers = JSON.parse(JSON.stringify(usersInGroup));
    // const removedElement = usersInGroup.splice(source.index, 1);
    // console.log("removed element: " + JSON.stringify(removedElement));
    // usersInGroup.splice(destination.index, 0, removedElement[0]);
    // console.log("currentUsers: " + JSON.stringify(usersInGroup));
    // console.dir(dataMap.get(548));
    // usersInGroup.map((data, index) => {
    //   console.log("user id in map loop : " + data.userId);
    //   const formData = dataMap.get(data.userId * 1);
    //   setValue(`users[${index}]`, { shouldDirty: true });
    //   let tempData = {
    //     ...data,
    //     label: formData.label,
    //     ring_type: formData.ring_type,
    //   };
    // });

    // //console.log("Final UsersGroup : " + JSON.stringify(usersInGroup));
    // replace(usersInGroup);

    //setValue(`users`, currentUsers);
    // const updatedList = [];
    // newItems.forEach((item, index) => {
    //   //let value = userDatarows[index];
    //   item.Order = index + 1;
    //   setValue(`users[${index}].Order`, item.Order, { shouldDirty: true });
    //   //  let data = usersInGroup[index];
    //   // let newOrder = index + 1;
    //   // let label = getValues(`users.${index}`);
    // });
    // // console.log("newItems ::::: " + usersInGroup);
    // console.log("Dirty Fields " + JSON.stringify(dirtyFields));
    // //addFieldsToUI();
    // //setUsersInGroup(usersInGroup);
    // setUserDatarows(newItems);
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: isDragging ? "none" : "auto",
    ...draggableStyle,
  });

  useEffect(() => {
    const filteredRows = userDatarows.filter((row) => {
      const order = row.Order.props.children.props.children[1]
      const name = row.Name ? row.Name.toLowerCase() : "";
      const extension = row.Extension ? row.Extension.toString() : "";
      const label = row.Label && row.Label.props && row.Label.props.children && row.Label.props.children.props.defaultValue
        ? row.Label.props.children.props.defaultValue.toLowerCase() : "";
      return name.includes(searchInput.toLowerCase()) ||
        extension.includes(searchInput) ||
        label.includes(searchInput.toLowerCase()) || order === (parseInt(searchInput));
    });
    setFilteredUserDatarows(filteredRows);
  }, [searchInput, userDatarows]);

  const fetchExistingUsers = async () => {
    try {
      setIsloading(true);
      console.log("[fetchExistingUsers] ");
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

      let serverResponse = await getExistingBlfUSersUnderGroup(siteid, groupid);

      if (!serverResponse.ok) {
        setTimeout(() => {
          setIsloading(false);
        }, 1000)
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        let usersdata = await serverResponse.json();
        console.log(
          "usersdata from Api server Response  :" + JSON.stringify(usersdata)
        );
        setUsersInGroup(usersdata.groupUsersInfo);
        const orders = usersdata.groupUsersInfo.map((item) => item.orders);
        console.log("Existing userIds List " + orders);
        setExistetOrdesList(orders);
        let alreadyExistingUsers = [];
        if (usersdata.groupUsersInfo.length > 0) {
          usersdata.groupUsersInfo.map((element) => {
            alreadyExistingUsers.push({
              name: element.name,
              extension: element.extension,
              agentid: element.agentid,
            });
          });
          setSelectedUsers(alreadyExistingUsers);
          console.log(
            "Exiting users framed data :" + JSON.stringify(alreadyExistingUsers)
          );
          setTimeout(() => {
            setIsloading(false);
          }, 1000)
        }
        if (usersdata.groupUsersInfo.length == 0) {
          setUserDatarows([]);
          console.log("No users found.");
          setTimeout(() => {
            setIsloading(false);
          }, 1000)
          return;
        }
        setValue("users", usersdata.groupUsersInfo);
        setTimeout(() => {
          setIsloading(false);
        }, 1000)
      }
      setTimeout(() => {
        searchRef.current.focus();
      },1000)
    } catch (e) {
      console.log("[BlfUsers.js][fetchExistingUsers] : " + e);
    }
  };

  const fetchAgentsInfo = async () => {
    try {
      console.log("[fetchAgentsInfo] ");
      let apiResponse = await getAgentsInAccount(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      console.log("[blfUsers] response  recieved for getAgentsInAccount");
      if (!apiResponse.ok) {
        console.log("Network response was not ok");
        //throw new Error('Network response was not ok');
      } else {
        let UserList = await apiResponse.json();
        UserList = UserList.agentsInfo;
        setAgentsInAccount(UserList);
      }
      setTimeout(() => {
        searchRef.current.focus();
      },1000)
    } catch (e) {
      console.error("Error in fetchAgentsInfo : " + e);
    }
  };
  const truncateLabel = (label, maxLength) => {
    if (label.length > maxLength) {
      return label.substring(0, maxLength);
    }
    return label;
  };
  const addnewUserstoGroup = async (selectedGroups) => {
    try {
      console.log("[addnewUsersGroups] :");
      console.dir(selectedGroups);
      let params = {};
      params.blf_group_id = groupid;
      params.reqid = 42;
      if (selectedGroups.length > 0) {
        let maxorderValue =
          existetOrdesList?.length > 0
            ? Math.max(...(existetOrdesList ?? [0]))
            : 0;
        params.users =
          selectedGroups.map((ele) => ({
            agentid: ele.agentid,
            label: truncateLabel(ele.name, 16),
            orders: ++maxorderValue,
          })) ?? [];
      }
      console.log("request params  :" + JSON.stringify(params));
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let serverResponse = await addNewUsersToBlfGroup(siteid, params);
      if (!serverResponse.ok) {
        setAddUser(!AddUser);
        console.log("network response is not ..!ok ");
        // throw new Error("Network response was not ok");
      } else {
        if (serverResponse.status == 200) {
          closeTogglePopup();
          console.log("Response recieved suceess 200");
          await fetchExistingUsers();
          checkPhoneErrors(groupid);
          setSuccessMessage(`User(s) added successfully.`);
          setAddUser(false);
        }
      }
    } catch (e) {
      console.error("[BlfUsers.js][addnewUserstoGroup] Exception :" + e);
    }
  };

  const checkPhoneErrors = async (groupid) => {
    try {
      console.log("checkPhoneErrors for groupid :" + groupid);
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let serverResponse = await getphoneErrors(siteid, groupid);
      if (!serverResponse.ok) {
        console.log("network response is not ..!ok ");
        // throw new Error("Network response was not ok");
      } else {
        if (serverResponse.status === 200) {
          console.log("[checkPhoneErrors] Response recieved suceess 200");
          let resp = await serverResponse.json();
          console.log(JSON.stringify(resp));
          if (resp.errormacs && resp.errormacs.length > 0) {
            setErrorDevices(resp.errormacs);
            togglephoneErrorpopup();
          }
        }
      }
    } catch (e) {
      console.error("Error in checkPhoneErrors :" + e);
    }
  }

  const deleteBlfpopup = async (e, element) => {
    console.log("Elemet :::::::::: " + JSON.stringify(element));
    if (element != null && element !== 'undefined' && Object.keys(element).length > 0) {
      console.log("[deleteBlfpopup] deleting blf group : " + element);
      // console.log(" popup status  : " + removeBlfGroup);
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let paramjo = {};
      paramjo.siteid = siteid;
      paramjo.agentid = element.agentid;
      let serverResponse = await confirmDeleteUserinPhones(siteid, paramjo);
      if (!serverResponse.ok) {
        console.log("Network response was not ok !! confirmDeleteUserinPhones");
      } else {
        let response = await serverResponse.json();
        //console.log("response 1:::::::::::::::" + JSON.stringify(response))
        if (response.configuredmacs.length > 0) {
          let macAdress = "";
          let macs = response.configuredmacs;

          for (let item of macs) {  // Use for...of loop to access each object directly
            console.dir(item);
            macAdress += item.macaddress + " ";  // Concatenate the macaddress values
          }

          element.devices = macAdress.trim();  // Trim to remove any trailing spaces
          setUserInfo(element);
          console.dir(response);
        } else {
          setUserInfo(element);
        }
        setRemoveBlfUser(!removeBlfUserInfo);

      }
    }
  }

  const deleteBlfUser = async (element) => {
    console.log("Elemet ::::::: " + JSON.stringify(element));
    try {
      console.log("deleteBlfUser particular element :");
      console.dir(element);
      let paramjo = {};
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      paramjo.siteid = siteid;
      paramjo.agentid = element.agentid;
      paramjo.reqid = 43;
      paramjo.blf_group_id = element.blf_group_id;
      console.log(
        "Sending request for deleteBlfGroup params : " + JSON.stringify(paramjo)
      );
      let serverResponse = await removeBlfUser(siteid, paramjo);
      setIsloading(true);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        setIsloading(false);
        // throw new Error("Network response was not ok");
      } else {
        console.log("User is deleted successfully :");
        setRemoveBlfUser(!removeBlfUserInfo);
        fetchExistingUsers();
        setUpdateSuccessMessage("User is removed successfully. ");
        setTimeout(() => { setIsloading(false) }, 1000);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  useEffect(() => {
    console.log("useEffect addFieldsToUI is callled....");
    addFieldsToUI();
  }, [fields]);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if (updatesuccessMessage) {
      setTimeout(() => {
        setUpdateSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [updatesuccessMessage]);

  const addFieldsToUI = () => {
    try {
      console.log(`fields :`, JSON.stringify(fields));
      if (fields.length > 0) {
        const uiData_rowsArray = fields.map((element, index) => {
          return {
            Order: (
              <>
                <div>
                  <img src={dotsIcon} className="close-icon" />
                  {index + 1}
                </div>
              </>
            ),
            Name: element.name,
            Extension: element.extension,
            Label: (
              <div   key={element.id}>
                <div className="phoneselect w-80">
                  <input 
                    type="text"
                    name={`users[${index}].label`}
                    maxLength={16}
                    onKeyDown={(event) => {
                      if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    className="form-control selectname-small w-100"
                    {...register(`users[${index}].label`)}
                  // onChange={(e) => handleInputChange(index, e)}
                  />
                </div>
              </div>
            ),
            Ring: (
              <div className="d-flex" key={element.id}>
                <select
                  className="form-control form-select selectname"
                  {...register(`users[${index}].ring_type`)}
                  name={`users[${index}].ring_type`}
                  onChange={(e) => {
                    if (e && e.target && e.target.value) {
                      setValue(`users[${index}].ring_type`, e.target.value, {
                        shouldDirty: true,
                      });
                    }
                  }}
                >
                  <option value="2">Silent</option>
                  <option value="1">Ring</option>
                </select>
              </div>
            ),
            // Delete: (
            //   <div
            //     title="Remove"
            //     className="cursor-pointer w-10 text-center"
            //     data={index}
            //     onClick={() => deleteBlfUser(element)}
            //   >
            //     <MDBIcon title="Remove" fas icon="times" color="primary" className="mt-3 ms-3" />
            //   </div>
            // ),

            Remove: (
              <>
                <div className="d-flex align-items-center ms-2 text-end">
                  <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deleteBlfpopup(e, element)}>
                    <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                  </div>
                </div>
              </>
            )
          };
        });
        setUserDatarows(uiData_rowsArray);
      }
    } catch (e) {
      console.log("Error in addFieldsToUI " + e);
    }
  };

  useEffect(() => {
    props.setFieldEdited(isDirty);

  }, [isDirty])

  const onsaveChanges = async (formdata) => {
    try {
      console.log("onsaveChanges  formdata: " + JSON.stringify(formdata));
      console.dir(formdata);
      console.log("dirty fields : " + JSON.stringify(dirtyFields));
      console.dir(dirtyFields);
      //we need to prepare api request parameters for only dirty fields in formdat
      let editedUsersArray = [];
      if (isDirty && Object.keys(dirtyFields).length > 0) {
        Object.keys(dirtyFields.users).map((key) => {
          console.log("key :::::  " + key + " " + formdata.users[key]);
          let jsonObj = formdata.users[key];
          if (jsonObj) {
            editedUsersArray.push({
              agentid: jsonObj.agentid,
              label: truncateLabel(jsonObj.label, 16),
              type: jsonObj.ring_type,
              orders: key * 1 + 1,
            });
          }
        });
      }
      const requestParamJo = {};
      requestParamJo.updateUsers = editedUsersArray;
      requestParamJo.blfGroupId = groupid;
      requestParamJo.reqid = 45;
      console.log("request params :::::::::" + JSON.stringify(requestParamJo));
      const apiRes = await editUsersfieldsUnderBlfGroup(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        requestParamJo
      );
      if (!apiRes.ok) {
        console.log("Network response is not ok!!!");
      } else {
        console.log("response success for updating users details");
        setUpdateSuccessMessage(`successfully updated.`);
        fetchExistingUsers();
      }
    } catch (e) {
      console.log("Error in onsaveChanges :" + e);
    }
  };
  const onCloseChanges = () => {
    console.log("usersInGroup ::::::  " + JSON.stringify(usersInGroup));
    reset({ users: usersInGroup });
  };

  useEffect(() => {
    fetchExistingUsers();
    fetchAgentsInfo();
  }, []);

  useEffect(() => {
    // Set default values when the API response is received
    console.log("Resetting ::::::::::form values");
    reset({ users: usersInGroup });
  }, [usersInGroup, reset]);

  const handleSearch = (e) => {
    const searchedValue = e.target.value.toLowerCase();

    const foundUser = usersInGroup.find((user) => {
      return (
        user.orders.toString().includes(searchedValue) || // Convert orders to string for comparison
        user.name.toLowerCase().includes(searchedValue) ||
        user.extension.toString().includes(searchedValue) || // Convert extension to string for comparison
        user.label.toLowerCase().includes(searchedValue)
      );
    });

    if (foundUser) {
      const output = {
        blf_group_id: foundUser.blf_group_id,
        label: foundUser.label,
        ring_type: foundUser.ring_type,
        userId: foundUser.userId,
        user_uuid: foundUser.user_uuid,
        name: foundUser.name,
        extension: foundUser.extension,
        agentid: foundUser.agentid,
        orders: foundUser.orders,
      };

      console.log("Output when record is matched:", output);
      // reset({ users: output });

      // You can perform any desired actions with this output
    } else {
      console.log("No user found with the searched value.");
      // Handle case when no user is found
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="actionbar"></div>
        <div className="add-numbermain noHoverBg d-flex justify-content-between ">
          <div className="dataTables_filter searchInput margin-end-10 ">
            <MDBInputGroup textAfter={<MDBIcon fas icon="search" />}>
              {/* <input
                type="text"
                className="form-control searchInput"
                id="datatable-search-input"
                onChange={(e) => handleSearch(e)}
              /> */}
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                ref={searchRef}
              />
              <label className="form-label" for="datatable-search-input">
                {/* {t("search")} */}
              </label>
            </MDBInputGroup>
          </div>
          <MDBBtn onClick={closeTogglePopup}> <MDBIcon fas icon="plus" color="light " className="me-1" /> {t("addusers")}</MDBBtn>
        </div>
        {/* Render the columns */}
        <div style={{ display: "flex" }} className="dragTable_header">
          {UserDataTable.columns.map((column) => (
            <div key={column.field} style={{ flex: 1, padding: "8px" }} className="fw-bold">
              {column.field}
            </div>
          ))}
        </div>

        {/* Render the rows */}
        <div className="datatableSelect blf-users-table" >
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {UserDataTable.rows.length > 0 ? <>

                    {UserDataTable.rows.map((row, index) => (
                      <Draggable
                        key={index}
                        draggableId={index.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            className="DragAndDropDiv_Align fw-bold"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              display: "flex",
                              ...getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              ),
                            }}
                          >
                            {UserDataTable.columns.map((column) => (
                              <div
                                key={column.field}
                                style={{ flex: 1, padding: "8px" }}
                              >
                                {row[column.field]}
                              </div>
                            ))}
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </> : <>
                    <p className="text-center">No Records Found</p>
                  </>}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div>
          {" "}
          {/* <MDBDatatable hover data={userDatarows} pagination={false} /> */}
        </div>
        {AddUser && (
          <PopupLoaderNew
            title={t("Add Users")}
            content={
              <AddToUsers
                sourceUsers={agentsInAccount}
                selectedUsers={selectedUsers}
                onAdd={addnewUserstoGroup}
                module="blfUsers"
                onClose={closeTogglePopup}
                ref={addUserRef}
                setIsloading={setisLoading}
              />
            }
            onShow={setAddUser}
            onClose={closeTogglePopup}
            onSave={handleClick}
            isloading={isLoading}
            flag={2}
          />
        )}

        {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}
        {removeBlfUserInfo && (
          <PopupLoader
            title={"Remove BLF User"}
            content={<RemoveBlfUserPopu userInfo={userInfo} onsave={deleteBlfUser} onClose={toggleRemoveBlfUserpopup} />}
            className={""}
            onShow={setRemoveBlfUser}
            onClose={toggleRemoveBlfUserpopup}
          />
        )}


        {phoneErrorpop && (<PopupLoader
          title={"Update BLF Group"}
          content={<PhoneErrorAlertpop devices={errorDevices} onClose={togglephoneErrorpopup} />}
          className={"modal-lg"}
          onShow={setphoneErrorpop}
          onClose={togglephoneErrorpopup}
        />)}


        {updatesuccessMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{updatesuccessMessage}</span>
          </MDBAlert>
        )}
        {isDirty && (
          <SaveChanges
            onClose={onCloseChanges}
            onSave={(e) => {
              handleSubmit(onsaveChanges)();
            }}
          />
        )}
        {isloading && (
          <div>
            <div className="loadingclass-popup"></div>
            <div className="popup-bg-loader loader_align">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </div>
        )}

        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );
}
